import {
  StyledAdvantagesStats,
  StyledDescription,
  StyledImage,
  StyledImageContainer,
  StyledNumbers,
  StyledStatContainer,
  StyledTextContent
} from "./styles";

import diamondImage from "@assets/imgs/diamond.png";
import girlImage from "@assets/imgs/girl.png";
import starImage from "@assets/imgs/star.png";
import { GridAdaptive } from "@components/GridAdaptive";
import React, { FC, memo } from "react";
import { useTranslations } from "next-intl";

interface AdvantagesStatsProps {
  className?: string;
  style?: React.CSSProperties;
}

const _AdvantagesStats: FC<AdvantagesStatsProps> = (props) => {
  const { ...restProps } = props;

  const t = useTranslations("AboutUsPage");

  return (
    <StyledAdvantagesStats {...restProps}>
      <GridAdaptive cols={{ desktop: 3, tablet: 1 }} columnGap={70} rowGap={50}>
        <StyledStatContainer>
          <StyledTextContent>
            <StyledDescription>
              {t("advantagesStats.stat_1.text_1")}
              <br />
              {t("advantagesStats.stat_1.text_2")}
              <br />
              {t("advantagesStats.stat_1.text_3")}
            </StyledDescription>
            <StyledNumbers>{`> 30 000`}</StyledNumbers>
          </StyledTextContent>
          <StyledImageContainer>
            <StyledImage
              src={diamondImage}
              width={149}
              height={128}
              alt={t("advantagesStats.stat_1.alt")}
            />
          </StyledImageContainer>
        </StyledStatContainer>
        <StyledStatContainer>
          <StyledTextContent>
            <StyledDescription>
              {t("advantagesStats.stat_2.text_1")}
              <br />
              {t("advantagesStats.stat_2.text_2")}
              <br />
              {t("advantagesStats.stat_2.text_3")}
            </StyledDescription>
            <StyledNumbers>{`> 2 700`}</StyledNumbers>
          </StyledTextContent>
          <StyledImageContainer>
            <StyledImage
              src={girlImage}
              width={104}
              height={160}
              alt={t("advantagesStats.stat_2.alt")}
            />
          </StyledImageContainer>
        </StyledStatContainer>
        <StyledStatContainer>
          <StyledTextContent>
            <StyledDescription>
              {t("advantagesStats.stat_3.text_1")}
              <br />
              {t("advantagesStats.stat_3.text_2")}
            </StyledDescription>
            <StyledNumbers>{`121%`}</StyledNumbers>
          </StyledTextContent>
          <StyledImageContainer>
            <StyledImage
              src={starImage}
              width={133}
              height={160}
              alt={t("advantagesStats.stat_3.alt")}
            />
          </StyledImageContainer>
        </StyledStatContainer>
      </GridAdaptive>
    </StyledAdvantagesStats>
  );
};

export const AdvantagesStats = memo(_AdvantagesStats);
